import { useSubscription } from "@apollo/client";




















































































export const useDataClientSubscription = useSubscription;
